<mat-toolbar class="footer">
  <span>
    Desenvolvido com
    <i class="material-icons v-middle" appRed> favorite </i>
    por <strong appRed>Alencartha</strong>
  </span>
</mat-toolbar>
